<template>
  <nav class="navbar" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <a
        class="navbar-item hidden-logo"
        href="http://www.cambridgeinternational.org"
        target="_blank"
      >
        <img class="logo-image" src="@/assets/img/cambridge-logo-lms.png" />
      </a>
      <router-link class="navbar-item logo-container" to="/">
        <img
          class="logo-image container-margin"
          style="margin-left:45px"
          src="https://generation-sis-assets.s3.eu-west-1.amazonaws.com/images/genex-logo-02.svg"
        />
      </router-link>

      <a
        role="button"
        class="navbar-burger burger"
        :class="{'is-active':showHamburger}"
        aria-label="menu"
        aria-expanded="false"
        data-target="navbarBasic"
        @click="showHamburger = !showHamburger"
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <div id="navbarBasic" class="navbar-menu" :class="{'is-active':showHamburger}">
      <div class="navbar-start">
        <router-link class="navbar-item" to="/courses">My Courses</router-link>
         <router-link class="navbar-item" to="/canvas" target="_blank">Canvas</router-link>
        <router-link class="navbar-item" to="/e-studio">E Studio</router-link>
        <router-link class="navbar-item" to="/faq">FAQ</router-link>

        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-item navbar-link">Contact</a>

          <div class="navbar-dropdown">
            <router-link to="/mentor" class="navbar-item">My Mentor</router-link>
            <router-link to="/support" class="navbar-item">Support</router-link>
            <router-link to="/contact" class="navbar-item">Genex</router-link>
          </div>
        </div>
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-item navbar-link">My Account</a>

          <div class="navbar-dropdown">
            <router-link to="/profile" class="navbar-item">My Profile</router-link>
            <a @click="logOut" class="navbar-item">Logout</a>
          </div>
        </div>
        <alerts />
        <a class="navbar-item is-hoverable" @click="$store.dispatch('search/toggleDisplay')">
          <span class="icon">
            <font-awesome-icon class="folder" :icon="'search'" />
          </span>
        </a>
      </div>

      <div class="navbar-end">
        <a
          class="navbar-item logo-container is-hidden-touch"
          href="http://www.cambridgeinternational.org"
          target="_blank"
        >
          <img class="logo-image" src="@/assets/img/cambridge-logo-lms.png" />
        </a>
      </div>
    </div>
  </nav>
</template>

<script>
import VueCookie from "vue-cookie";
import alerts from "@/components/layout/Alerts.vue";

export default {
  name: "Navbar",
  components: { alerts },
  data: function() {
    return {
      showHamburger: false
      // dummyAlert: [{ message: "bob", url: "bob", id: "bob" }]
    };
  },
  methods: {
    logOut() {
      // this.$store.dispatch("auth/delete");
      VueCookie.delete("access_token");
      this.$router.go("login");
    }
  }
};
</script>


<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
@media (min-width: 1088px) {
  .navbar-item.is-hoverable:hover .navbar-dropdown {
    display: block;
  }
}
.logo-image {
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 0;
  height: auto;
  &.container-margin {
    @media screen and (min-width: 1025px) {
      margin-left: 45px;
    }
  }
}

.logo-container {
  width: 20vw;
  // margin-bottom: $navbar-offset;
  @media screen and (max-width: 1087px) {
    margin-right: auto !important;
    width: 33vw;
  }
}
.navbar {
  margin-bottom: 1rem;
}
.hidden-logo {
  width: 33vw;
  margin-right: auto;
  @media screen and (min-width: 1088px) {
    display: none;
  }
}
.navbar-menu {
  .navbar-item {
    height: fit-content;
    margin: auto auto 0 auto;
    text-transform: uppercase;
  }
  .navbar-start {
    width: 80%;
    margin: 0;
    // .navbar-item {
    //   margin-bottom: $navbar-offset;
    // }
    :first-child {
      margin-left: 0;
    }
  }
}
</style>
